<div class="dmp-toast-viewport" aria-label="Notifications">
  @for (toast of toasts$ | async; track trackById($index, toast)) {
    <div
      class="dmp-toast"
      [class.dmp-toast--leaving]="toast.leaving"
      [class.dmp-toast--error]="toast.severity === 'error'"
      [class.dmp-toast--warning]="toast.severity === 'warning'"
      [class.dmp-toast--success]="toast.severity === 'success'"
      [class.dmp-toast--info]="toast.severity === 'info'"
      [attr.role]="role(toast.severity)"
      [attr.aria-live]="ariaLive(toast.severity)">
      <span class="dmp-toast__icon" aria-hidden="true">
        @switch (toast.severity) {
          @case ('error') {
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-5.25a.75.75 0 001.5 0v-5.5a.75.75 0 00-1.5 0v5.5zm.75 3.25a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd" />
            </svg>
          }
          @case ('warning') {
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
              <path
                fill-rule="evenodd"
                d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6.75a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6.75zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd" />
            </svg>
          }
          @case ('success') {
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                clip-rule="evenodd" />
            </svg>
          }
          @default {
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                clip-rule="evenodd" />
            </svg>
          }
        }
      </span>

      <p class="dmp-toast__message">{{ toast.message }}</p>

      <button
        type="button"
        class="dmp-toast__close"
        aria-label="Dismiss notification"
        (click)="dismiss(toast.id)">
        <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14" aria-hidden="true">
          <path
            d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>
    </div>
  }
</div>
